import { Component, Input, OnInit } from '@angular/core';
import { TotalSoldHoursResponseModel } from 'projects/Administration/src/app/business-entities/total-sold-hours-report-model';
import { MultiStackPopupService } from 'projects/Administration/src/app/services/multi-stack-popup.service';

@Component({
  selector: 'app-total-sold-hours-details-grid',
  templateUrl: './total-sold-hours-details-grid.component.html',
})
export class TotalSoldHoursDetailsGridComponent implements OnInit {
  @Input() soldHoursDetailsGridData: TotalSoldHoursResponseModel[] = [];
  dateTimeFormat: string = 'dd.MM.yyyy, HH:mm:ss';

  constructor(private multiStackPopupService: MultiStackPopupService) {}

  ngOnInit(): void {}

  openAppointment(appointmentId) {
    this.multiStackPopupService.OpenAppointment(appointmentId, false);
  }

  getDurationInHours(minutes: number) {
    return minutes > 0 ? minutes / 60 : 0;
  }
}
